import { Rating, Stack, Typography, lighten } from "@mui/material";
import { FONT_COLORS } from "../../../../constants";
import TitleWithEllipsis from "../TitleWithEllipsis";

interface IProductInfoProps {
  product: {
    asin: string;
    title: string;
    rating: number;
    reviews: number;
    upc: string;
    isbn: string;
  };
  onProductClick: (asin: string) => void;
}

const ProductInfo = ({ product, onProductClick }: IProductInfoProps) => {
  return (
    <>
      <TitleWithEllipsis
        sx={{ fontSize: 12, fontWeight: 700 }}
        onClick={() => onProductClick(product.asin)}
        underline="hover"
      >
        {product.title}
      </TitleWithEllipsis>
      <Stack flexDirection="row" gap={0.5} alignItems="center" my={0.5}>
        <Rating precision={0.5} value={product.rating} size="small" readOnly />
        <Typography variant="body2">
          {Intl.NumberFormat("en-US", {
            useGrouping: true,
          }).format(product.reviews)}
        </Typography>
      </Stack>
      <Typography variant="body2">
        <Typography
          variant="body2"
          component="span"
          color={lighten(FONT_COLORS.default, 0.4)}
        >
          ASIN:&nbsp;
        </Typography>
        {product.asin}
      </Typography>
      {!!product.upc && (
        <Typography variant="body2">
          <Typography
            variant="body2"
            component="span"
            color={lighten(FONT_COLORS.default, 0.4)}
          >
            UPC:&nbsp;
          </Typography>
          {product.upc}
        </Typography>
      )}
      {!!product.isbn && (
        <Typography variant="body2">
          <Typography
            variant="body2"
            component="span"
            color={lighten(FONT_COLORS.default, 0.4)}
          >
            ISBN:&nbsp;
          </Typography>
          {product.isbn}
        </Typography>
      )}
    </>
  );
};

export default ProductInfo;
